export function LastReadDivider(): React.JSX.Element {
  return (
    <div className="flex items-center gap-2 my-2">
      <div className="flex-1 border-t border-bear-red/50" />
      <span className="text-xs text-bear-red/70 font-medium">Last Read</span>
      <div className="flex-1 border-t border-bear-red/50" />
    </div>
  );
}
